import Vue from "vue";
import messages from "../../../languages/index";
import store from "../../../store";
let language = store.state.language || "pt";

const RoutersUser = [
  {
    path: "user/list-bet",
    name: "Apostas",
    icon: "mdi-ticket-confirmation-outline",
    meta: {
      nameDrawer: messages[language].bets,
      filterLimitDays: 7,
      group: true,
      operator: true,
    },
    children: [
      {
        path: "sportsBetting",
        name: "SportBets",
        icon: "mdi-soccer",
        meta: {
          nameDrawer: messages[language].sports,
          operator: true,
          filters: ["RangeGlobal", "SelectStatusBetOnline", "EventNumber"],
        },
        component: () => import("./betOnline/sportsBetting.vue"),
      },
      {
        path: "casinoBetting",
        name: "CasinoBets",
        icon: "mdi-dice-5-outline",
        meta: {
          nameDrawer: messages[language].casino,
          operator: store.state.operators.casino > 0
            && store.state.operators.credit == 2
            ? true
            : false,
          filters: ["CasinoRange", "CasinoBetsStatus"],
        },
        component: () => import("./betOnline/casinoBetting.vue"),
        beforeEnter: (to, from, next) => {
          if (
            store.state.operators.casino > 0
            && store.state.operators.credit == 2
          ) {
            next();
          } else {
            next("/");
          }
        },
      },
    ],
    operator: true,
    component: () =>
      new Promise((resolve) => {
        Vue.prototype.$isCreditOnline()
          ? resolve(import("./betOnline/onlineBetting.vue"))
          : resolve(import("./bet/list-bet.vue"));
      }),
  },
  {
    path: "user/bank",
    name: "Banco",
    icon: "mdi-bank",
    meta: {
      nameDrawer: messages[language].bank,
    },
    operator: true,
    component: () =>
      new Promise((resolve) => {
        Vue.prototype.$isCreditOnline()
          ? resolve(import("./bankOnline/bankOnline"))
          : resolve(import("./bank"));
      }),
    beforeEnter: (to, from, next) => {
      if (Vue.prototype.$isRetailSimplifiedOnly()) {
        next("/");
      } else {
        next();
      }
    },
  },
  {
    path: "promotions",
    name: "MyPromotions",
    icon: "mdi-gift-outline",
    meta: {
      nameDrawer: messages[language].myPromotions,
    },
    operator: true,
    component: () => import("./promotions/index.vue"),
    beforeEnter: (to, from, next) => {
      if (Vue.prototype.$isCreditOnline()) {
        next();
      } else {
        next("/");
      }
    },
  },
  //Mensagens para o jogador
  {
    path: "user/mensagens",
    name: "Mensagens",
    icon: "mdi-email-outline",
    meta: {
      nameDrawer: messages[language].messages,
    },
    operator: true,
    component: () => import("./settings/messages"),
  },
  {
    path: "user/profile",
    name: "Perfil",
    icon: "mdi-account-circle-outline",
    meta: {
      nameDrawer: messages[language].profile,
    },
    operator: true,
    component: () => import("./settings/profile"),
  },
  {
    path: "user/verify",
    name: "Verify",
    icon: "mdi-shield-check-outline",
    meta: {
      nameDrawer: messages[language].verification.pageName,
    },
    operator: true,
    component: () => import("./verify"),
    beforeEnter: (to, from, next) => {
      if (Vue.prototype.$isCreditOnline()) {
        next();
      } else {
        next("/");
      }
    },
  },
];
export default RoutersUser;
